module.exports = __webpack_public_path__ + "img/Jess_and_I_house.0ff1e0ee.jpeg";